import {dispatch, make} from 'vuex-pathify'
import router from "@/router";
import {
    postSBResultApi,
    postSBEductionFundResultDataApi,
    getSBResultApi,
    getTripleIResultApi, updateSBResultApi, getSBCombinePremiumApi
} from "@/func/api";

const state = function () {
    return {
        postData: {},
        plan: {},
        token: '',
        apiData: {},
        tripleIData: {},
        isEmpty: false,
        result: {
            hasData: false,
        },
        formData: {
            alreadyPrepare: 0,
            gender: "",
            currentAge: 0,
            birthdayY: 0,
            birthdayM: 0,
            birthdayD: 0,
            isFirst: false,
            yearGetBack: 0
        },
        premium_1:0,
        premium_2:0,
        data: [],
    }
}

const mutations = make.mutations(state)
const actions = {
    ...make.actions(['postData', 'formData', 'tripleIData', 'result', 'data', 'plan']),
    setPostData(context, {page_no, page_answer}) {
        let postData = context.state.postData
        postData[page_no] = page_answer
        context.commit('postData', postData)
    },
    async sendTripleIEducationFundApi({state, getters, commit}) {
        // Get 3iii 結果頁資料
        let data = {
            gender: state.formData.gender,
            Age: state.formData.currentAge,
            saveAmountPerMonth: state.apiData.years_getback <= 6 ?
                state.formData.alreadyPrepare / 12 :
                getters.suggestSavePerMoney,
            yearGetBack: state.apiData.years_getback
        }
        const res = await getTripleIResultApi(data)
        commit('tripleIData', res.data)
    },
    async sendSBCombinePremiumApi({state, commit}) {
        let token_1 = state.formData.currentAge < 45 ?
        '70bdb9ef4a7a7cd1b1c009ae1667b146' :
        '7feadebcb61c2dc39a74e38df307d830'

        let token_2 = '7116ec4f16016a88d94bb8f1934f8f82'

        let premium_1_data = {
            gender: state.formData.gender === "MALE" ? 1 : 2,
            age: state.formData.currentAge,
            job: 1,
            id: token_1,
        }
        let premium_2_data = {
            gender: state.formData.gender === "MALE" ? 1 : 2,
            age: state.formData.currentAge,
            job: 1,
            id: token_2,
        }

        const premium_1 = await getSBCombinePremiumApi(premium_1_data)
        const premium_2 = await getSBCombinePremiumApi(premium_2_data)
        commit('premium_1', premium_1.data)
        commit('premium_2', premium_2.data)
    },
    async sendSBEductionFundResultDataApi({state, commit}) {
        let talentSpent = 0
        let kidAge = []
        let schoolArr = []
        state.postData[2].forEach(item => kidAge.push(item))

        let answer_7 = state.postData[7] || []
        answer_7.forEach(item => schoolArr.push(item.value))

        let answer_6 = state.postData[6] || []
        answer_6.forEach(item => {
            let value = parseInt(item.value) || 0
            talentSpent += value
        })

        let data = {
            school: {
                kindergarten: state.postData[3].kindergarten,
                elementary: state.postData[3].elementary,
                junior: state.postData[3].junior,
                high: 208000, // 固定
                university: JSON.parse(state.postData[8].value)[0],
                graduate: JSON.parse(state.postData[8].value)[1],
            },
            kids: kidAge,
            talent: {
                spend: talentSpent,
                school: schoolArr,
            },
            bonus: state.postData[4],
        }

        const res = await postSBEductionFundResultDataApi(data)
        commit('apiData', res.data.data)
    },
    async getSBEducationFundData({state, commit}, payload) {
        try {
            const res = await getSBResultApi(payload)
            if (res.status === 200) {
                let data = JSON.parse(res.data.data.a_json_data)
                commit('result', data)
                commit('postData', data.postData)
                commit('apiData', data.apiData)
                commit('formData', data.formData)
                commit('tripleIData', data.tripleIData)
                commit('premium_1', data.premium_1)
                commit('premium_2', data.premium_2)
            } else {
                console.log('error')
                await router.push({name: store.get('moduleName')})
            }
        } catch (e) {
            console.log(e)
            await router.push({name: store.get('moduleName')})
        }
    },
    async saveSBData({state, commit}) {
        let data = {
            a_json_data: state.result
        }
        const res = await postSBResultApi(data)
        commit('token', res.data.data.a_uniqid)
    },
    async updateSBData({state, commit, dispatch}, {token, planObj}) {
        if (planObj) await commit('plan', planObj)

        await dispatch('sendSBCombinePremiumApi')
        await dispatch('setResultData')

        let data = {
            a_json_data: state.result,
            a_uniqid: token
        }
        const res = await updateSBResultApi(data)

        if (res.data.status === 200 && planObj)
            document.location.href = (`/form/order/needs_analysis/education_fund?tk=${token}`);

        if (res.data.status !== 200) {
            alert('好像遇到麻煩囉！請重新操作')
            await router.push({name: store.get('moduleName')})
        }
    },
    setResultData({commit, state, getters}) {
        let result = {
            hasData: true,
            plan: state.plan,
            postData: state.postData,
            formData: state.formData,
            tripleIData: state.tripleIData,
            apiData: state.apiData,
            kidAmount: state.postData[1],
            kidsEducationFund: getters.kidsEducationFund,
            kidsEducationStage: getters.kidsEducationStage,
            needPreparedFund: Math.round(state.apiData.total),
            alreadyPrepare: state.formData.alreadyPrepare,
            lackPrepareFund: Math.round(getters.lackPrepareFund),
            suggestSavePerMoney: getters.suggestSavePerMoney,
            achievementRate: getters.achievementRate,
            yearGetBack: state.tripleIData.yearGetBack,
            t_returnRate: getters.t_returnRate,
            t_saveInRowYear: state.tripleIData.t_payYear,
            t_saveInRowAmount: state.tripleIData.t_amount,
            t_getAmount: state.tripleIData.t_getAmount,
            t_raisedAchievementRate: getters.t_raisedAchievementRate,
            u_returnRate: getters.u_returnRate,
            u_saveInRowYear: state.tripleIData.t_payYear,
            u_saveInRowAmount: state.tripleIData.t_amount,
            u_getAmount: state.tripleIData.u_getAmount,
            u_raisedAchievementRate: getters.u_raisedAchievementRate,
            premium_1: state.premium_1,
            premium_2: state.premium_2,
        }
        commit('result', result)
    },
}

const getters = {
    achievementRate(state) {
        return Math.ceil(state.formData.alreadyPrepare * 100 / state.apiData.total)
    },
    suggestSavePerMoney(state, getters) {
        let suggestSavePerMoney = Math.round(getters.lackPrepareFund / state.apiData.years_getback / 12)
        return suggestSavePerMoney > 0 ? suggestSavePerMoney : 0
    },
    lackPrepareFund(state) {
        return (state.apiData.total - state.formData.alreadyPrepare) > 0 ?
            Math.round(state.apiData.total - state.formData.alreadyPrepare) : 0
    },
    kidsEducationFund(state) {
        let total = 0
        let kindergartenEduFund = 0
        let elementaryEduFund = 0
        let juniorEduFund = 0
        let highEduFund = 0
        let universityEduFund = 0
        let graduateEduFund = 0
        state.apiData.kids.forEach(kid => {
            kindergartenEduFund += kid.edu_funds.kindergarten
            elementaryEduFund += kid.edu_funds.elementary
            juniorEduFund += kid.edu_funds.junior
            highEduFund += kid.edu_funds.high
            universityEduFund += kid.edu_funds.university
            graduateEduFund += kid.edu_funds.graduate
            Object.values(kid.edu_funds).forEach(value => total += value)
        })

        let data = {
            kindergarten: Math.ceil(kindergartenEduFund),
            elementary: Math.ceil(elementaryEduFund),
            junior: Math.ceil(juniorEduFund),
            high: Math.ceil(highEduFund),
            university: Math.ceil(universityEduFund),
            graduate: Math.ceil(graduateEduFund),
            kindergartenPercent: Math.round(kindergartenEduFund * 100 / total),
            elementaryPercent: Math.round(elementaryEduFund * 100 / total),
            juniorPercent: Math.round(juniorEduFund * 100 / total),
            highPercent: Math.round(highEduFund * 100 / total),
            universityPercent: Math.round(universityEduFund * 100 / total),
            graduatePercent: Math.round(graduateEduFund * 100 / total),
            total: Math.ceil(total),
        }

        let percents = [
            data.kindergartenPercent,
            data.elementaryPercent,
            data.juniorPercent,
            data.universityPercent,
            data.graduatePercent,
        ]
        let lastPercent = 0
        percents.forEach(item => lastPercent += item)
        data.highPercent = 100 - lastPercent

        return data
    },
    kidsEducationStage(state) {
        let kidsStage = []
        state.apiData.kids.forEach(kid => kidsStage.push(kid.edu_stage_advice))
        return kidsStage
    },
    t_returnRate(state) {
        //報酬率(%)＝{ ( t_getAmount - t_amount * t_payYear ) / ( t_amount * t_payYear ) } * 100
        return Math.ceil((state.tripleIData.t_getAmount - state.tripleIData.t_amount * state.tripleIData.t_payYear) * 100 /
            (state.tripleIData.t_amount * state.tripleIData.t_payYear))
    },
    t_raisedAchievementRate(state) {
        return Math.ceil((state.tripleIData.t_getAmount - state.tripleIData.t_amount * state.tripleIData.t_payYear) * 100 / state.apiData.total)
    },
    u_returnRate(state) {
        //報酬率(%)＝{ ( u_getAmount - u_amount * u_payYear ) / ( u_amount * u_payYear ) } * 100
        return Math.ceil((state.tripleIData.u_getAmount - state.tripleIData.u_amount * state.tripleIData.u_payYear) * 100 * 28.5 /
            (state.tripleIData.u_amount * state.tripleIData.u_payYear * 28.5))
    },
    u_raisedAchievementRate(state) {
        return Math.ceil((state.tripleIData.u_getAmount - state.tripleIData.u_amount * state.tripleIData.u_payYear) * 100 * 28.5 / state.apiData.total)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
